module.exports = __webpack_public_path__ + "static/pakmaya-web-98b8ce1d5d002686911bc52666d97830.jpg";